// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18W-Q","label":"styles_label__3a6la"};